import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import { ApiError } from '@/shared/api/client.ts'

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: (attempt, error) => attempt < 2 && !(error instanceof ApiError && error.isUnauthorized),
        refetchOnWindowFocus: false,
        staleTime: 60 * 1000,
      },
      mutations: { retry: false },
    },
  })

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient)

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
